module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "macbook",
    style: ({
      'background-image': 'url(' + _vm.image + ')'
    })
  }, [_c('img', {
    attrs: {
      "src": "/static/base/macbook-frame.png",
      "alt": 'Macbook with image of ' + _vm.name + '.'
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93f04b1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project-macbook/ProjectMacbook.vue
// module id = 92
// module chunks = 0